import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonTable from "../../../../components/Table/Table";
import "./metal_purity_karatList.css";
import { getAllDesired } from "../../../../services/DesiredType/DesiredType.service";
import {
  getAllMetalPurityCarat,
  updateMetalPurityCarat,
  deleteMetalPurityCarat,
} from "../../../../services/metal_purity_karat/metal_purity_karat.service";
import { MetalPurityCaratType } from "../../../../services/metal_purity_karat/metal_purity_karat.types";
import { Pencil, Eye, Trash2 } from "lucide-react";
import { toast } from "react-toastify";
const MetalPurityCaratList: React.FC = () => {
  const [search, setSearch] = useState("");
  const [data, setData] = useState<MetalPurityCaratType[]>([]);
  const [selectedRow, setSelectedRow] =
    useState<MetalPurityCaratType | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const navigate = useNavigate();
  const calledOnce = useRef(false);
  const [metalTypes, setMetalTypes] = useState<any[]>([]);
  const [selectedMetal, setSelectedMetal] = useState("");

  const loadData = async () => {
    try {
      const response = await getAllMetalPurityCarat();
      const list = response.data || [];
      const sorted = [...list].sort(
        (a: any, b: any) => (b?.id ?? 0) - (a?.id ?? 0)
      );
      setData(sorted);
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    }
  };

  useEffect(() => {
    if (calledOnce.current) return;
    calledOnce.current = true;
    loadData();
    fetchMetalTypes();
  }, []);



  const fetchMetalTypes = async () => {
    try {
      const res = await getAllDesired();
      setMetalTypes(res.data || []);
    } catch (err) {
      // console.log("Metal fetch error", err);
    }
  };
  const toggleStatus = async (row: MetalPurityCaratType) => {
    try {
      await updateMetalPurityCarat(row.id!, {
        isActive: !row.isActive,
      });

      const updated = data.map((item) =>
        item.id === row.id
          ? { ...item, isActive: !item.isActive }
          : item
      );

      setData(updated);
      toast.success(`Status updated successfully`);
    } catch (error) {
      console.error("Status update failed", error);
    }
  };

  // ✅ Updated Search (Gold + Diamond dono ke liye)
  const filtered = data.filter((item) => {
    const searchText = search.toLowerCase();

    const matchesSearch =
      item.karat?.toLowerCase().includes(searchText) ||
      item.purity?.toString().includes(searchText) ||
      item.carat?.toString().includes(searchText) ||
      item.centValue?.toString().includes(searchText) ||
      item.Metal_type?.name?.toLowerCase().includes(searchText);

    const matchesMetal = selectedMetal
      ? item.metalTypeId === Number(selectedMetal)
      : true;

    return matchesSearch && matchesMetal;
  });

  const totalPages = Math.ceil(filtered.length / itemsPerPage) || 1;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filtered.slice(
    startIndex,
    startIndex + itemsPerPage
  ).map((item, index) => ({
    ...item,
    serial: startIndex + index + 1,
  }));

  const handleDelete = async (id?: number) => {
    if (!id) return;
    try {
      await deleteMetalPurityCarat(id);
      setData((prev) => prev.filter((item) => item.id !== id));
      toast.success("Deleted successfully");
    } catch (error) {
      console.error("Delete failed", error);
      toast.error("Failed to delete");
    }
  };

  const columns = [
    { key: "serial", label: "S.NO" },

    {
      key: "metalType",
      label: "Metal Type",
      render: (_: any, row: MetalPurityCaratType) =>
        row.Metal_type?.name,
    },

    {
      key: "karat",
      label: "Karat",
      render: (_: any, row: MetalPurityCaratType) =>
        row.metalTypeId === 1 ? row.karat || "0" : "0",
    },

    {
      key: "purity",
      label: "Purity (%)",
      render: (_: any, row: MetalPurityCaratType) =>
        row.metalTypeId === 1 || row.metalTypeId === 3
          ? row.purity ?? "0"
          : "0",
    },

    {
      key: "carat",
      label: "Carat",
      render: (_: any, row: MetalPurityCaratType) =>
        row.metalTypeId === 2 ? row.carat ?? "0" : "0",
    },

    {
      key: "centValue",
      label: "Cent Value",
      render: (_: any, row: MetalPurityCaratType) =>
        row.metalTypeId === 2 ? row.centValue ?? "0" : "0",
    },

    {
      key: "isActive",
      label: "Status",
      render: (value: boolean, row: MetalPurityCaratType) => (
        <span
          className="status-badge"
          style={{
            backgroundColor: value ? "#d4f5d4" : "#f5d4d4",
            color: value ? "green" : "red",
            cursor: "pointer",
            padding: "4px 8px",
            borderRadius: "6px",
            fontWeight: 500,
          }}
          onClick={() => toggleStatus(row)}
        >
          {value ? "Active" : "Inactive"}
        </span>
      ),
    },
  ];

  return (
    <div className="category-container">
      <div className="header-bar">
        <div style={{ display: "flex", gap: "10px" }}>

          {/* 🔍 Search */}
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
            className="search-bar"
          />

          {/* 🔽 Metal Filter */}
          <select
            className="filter-select"
            value={selectedMetal}
            onChange={(e) => {
              setSelectedMetal(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="">All Metals</option>
            {metalTypes.map((metal) => (
              <option key={metal.id} value={metal.id}>
                {metal.name}
              </option>
            ))}
          </select>

        </div>

        <button
          className="add-btn"
          onClick={() => navigate("/add/metal-purity-carat")}
        >
          Add Metal Purity
        </button>
      </div>

      <CommonTable
        columns={columns}
        data={paginatedData}
        tableClassName="compact-table"
        actions={(row) => (
          <div className="action-icons">
            <button
              className="icon-btn"
              onClick={() => setSelectedRow(row)}
            >
              <Eye size={16} />
            </button>

            <button
              className="icon-btn"
              onClick={() =>
                navigate(`/edit/metal-purity-carat/${row.id}`)
              }
            >
              <Pencil size={16} />
            </button>

            <button
              className="icon-btn delete"
              onClick={() => handleDelete(row.id)}
              title="Delete"
            >
              <Trash2 size={16} color="#ef4444" />
            </button>
          </div>
        )}
      />

      <div className="pagination">
        <button
          onClick={() =>
            setCurrentPage((p) => Math.max(p - 1, 1))
          }
          disabled={currentPage === 1}
        >
          Previous
        </button>

        <span>
          Page {currentPage} of {totalPages}
        </span>

        <button
          onClick={() =>
            setCurrentPage((p) =>
              Math.min(p + 1, totalPages)
            )
          }
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>

      {selectedRow && (
        <div
          className="modal-overlay"
          onClick={() => setSelectedRow(null)}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Metal Purity Details</h3>
            <table className="details-table">
              <tbody>
                <tr>
                  <td>ID</td>
                  <td>{selectedRow.id}</td>
                </tr>

                <tr>
                  <td>Metal Type</td>
                  <td>{selectedRow.Metal_type?.name || "-"}</td>
                </tr>
                {selectedRow.metalTypeId === 1 && (selectedRow.karat || selectedRow.purity) && (
                  <>
                    {selectedRow.karat && (
                      <tr>
                        <td>Karat</td>
                        <td>{selectedRow.karat}</td>
                      </tr>
                    )}
                    {selectedRow.purity !== null && selectedRow.purity !== undefined && (
                      <tr>
                        <td>Purity</td>
                        <td>{selectedRow.purity}</td>
                      </tr>
                    )}
                  </>
                )}

                {selectedRow.metalTypeId === 3 && selectedRow.purity !== null && selectedRow.purity !== undefined && (
                  <tr>
                    <td>Purity</td>
                    <td>{selectedRow.purity}</td>
                  </tr>
                )}

                {selectedRow.metalTypeId === 2 && (selectedRow.carat || selectedRow.centValue !== null && selectedRow.centValue !== undefined) && (
                  <>
                    {selectedRow.carat && (
                      <tr>
                        <td>Carat</td>
                        <td>{selectedRow.carat}</td>
                      </tr>
                    )}
                    {selectedRow.centValue !== null && selectedRow.centValue !== undefined && (
                      <tr>
                        <td>Cent Value</td>
                        <td>{selectedRow.centValue}</td>
                      </tr>
                    )}
                  </>
                )}
              </tbody>
            </table>

            <button
              className="add-btn"
              style={{ marginTop: "15px" }}
              onClick={() => setSelectedRow(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MetalPurityCaratList;
